module.exports = __webpack_public_path__ + "static/media/confeitaria-duque-caxias-logo-branding.34f22c0d.jpg";